import { render } from "./origo-user-guide-component.vue?vue&type=template&id=6430f0f0"
import script from "./origo-user-guide-component.vue?vue&type=script&lang=js"
export * from "./origo-user-guide-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__